export const aciWashingMachine = {
    iconName: 'washing-machine',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M18.645 3.594H6.316a1.12 1.12 0 00-1.12 1.12v14.571c0 .62.501 1.121 1.12 1.121h12.329a1.12 1.12 0 001.12-1.12V4.714a1.12 1.12 0 00-1.12-1.12zM7.438 5.836h2.241M5.195 8.077h14.57',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M12.48 18.164a3.923 3.923 0 100-7.845 3.923 3.923 0 000 7.845z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M13.601 6.116a.28.28 0 110-.56M13.6 6.116a.28.28 0 000-.56M16.964 6.116a.28.28 0 110-.56M16.964 6.116a.28.28 0 000-.56',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                },
            },
            {
                attr: {
                    d: 'M10.799 14.242a1.682 1.682 0 011.681-1.682',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
